export const config = {
  apiKey: 'AIzaSyBeKdNAX1_JHeGnPouQTYH0d3APAYzRZVY',
  authDomain: 'eye-school-test.firebaseapp.com',
  databaseURL: 'https://eye-school-test.firebaseio.com',
  projectId: 'eye-school-test',
  storageBucket: 'eye-school-test.appspot.com',
  messagingSenderId: '1082968904935',
};



// WEBPACK FOOTER //
// ./src/config/db.development.js